import { Category } from "@mui/icons-material"
import { List } from "@mui/material"

export const API_BASE_URL = 'https://dev.api.askmilo.ai'
//export const API_BASE_URL = 'http://192.168.29.54:4000'
export const MEDIA_URL = 'https://askmilo.s3.us-east-2.amazonaws.com'

export const ApiEndpoints = {
  LEGAL_CONTENT: {
    privacy: `${API_BASE_URL}/api/users/misc/legalcontent/privacy_policy`,
    terms: `${API_BASE_URL}/api/users/misc/legalcontent/terms_and_conditions`
  },
  CONTACTUS: {
    add: `${API_BASE_URL}/api/users/contact/us`,
    create: `${API_BASE_URL}/api/users/subscribe/email`
  },
  PROMPT: {
    list: `${API_BASE_URL}/api/users/misc/prompts`,
    mostUsedCategory: `${API_BASE_URL}/api/users/misc/most-used/category`,
  },
  SUBSCRIPTIONS: {
    planList: `${API_BASE_URL}/api/users/misc/subscriptionplans`
  },
  CATEGORY: {
    list: `${API_BASE_URL}/api/users/misc/category`
  },
  BLOG: {
    list: `${API_BASE_URL}/api/users/misc/blogs`,
    listbyid: id => `${API_BASE_URL}/api/users/misc/blogs/${id}`
  },
  FAQ: {
    list: `${API_BASE_URL}/api/users/misc/faqs`
  },
}
